import { createContext } from 'react';
import { User } from '../classes/entities/User/userTypes';
import { UserPermissions } from '../classes/misc/UserPermissions/UserPermissions';

export const currentUserContextDefaultValue: CurrentUserContextValue = {
  get currentUser(): never {
    throw new Error(
      'CurrentUserContext not initialized, make sure you are inside the CurrentUserContext'
    );
  },
  get getRequiredCurrentUser(): never {
    throw new Error(
      'CurrentUserContext not initialized, make sure you are inside the CurrentUserContext'
    );
  },
  get getRequiredCurrentUserPermissions(): never {
    throw new Error(
      'CurrentUserContext not initialized, make sure you are inside the CurrentUserContext'
    );
  }
};

export const CurrentUserContext = createContext<CurrentUserContextValue>(
  currentUserContextDefaultValue
);

export type CurrentUserContextValue = {
  currentUser: User | null;
  getRequiredCurrentUser: () => User;
  getRequiredCurrentUserPermissions: () => UserPermissions;
};
